var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDrawerHandle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 5,
    viewBox: "0 0 41 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.427734,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#C2C7D0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDrawerHandle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drawer_handle.a1ff9de3b0f90e34a262dc55d6c02d0d.svg";